export function convertHTMLToPlainText(htmlString?: string) {
    if (!htmlString) {
        return "";
    }
    let parser = htmlString;
    parser = parser.replace(/\n/gi, "");
    parser = parser.replace(/<style([\s\S]*?)<\/style>/gi, "");
    parser = parser.replace(/<script([\s\S]*?)<\/script>/gi, "");
    parser = parser.replace(/<a.*?href="(.*?)[?"].*?>(.*?)<\/a.*?>/gi, " $2 $1 ");
    parser = parser.replace(/<\/div>/gi, "\n\n");
    parser = parser.replace(/<\/li>/gi, "\n");
    parser = parser.replace(/<link.*?>/gi, "");
    parser = parser.replace(/<li.*?>/gi, "  *  ");
    parser = parser.replace(/<\/ul>/gi, "\n\n");
    parser = parser.replace(/<\/p>/gi, "\n\n");
    
    parser = parser.replace(/<br\s*[\/]?>/gi, "\n");
    parser = parser.replace(/<[^>]+>/gi, "");
    parser = parser.replace(/^\s*/gim, "");
    parser = parser.replace(/ ,/gi, ",");
    parser = parser.replace(/ +/gi, " ");
    parser = parser.replace(/\n+/gi, "\n\n");

    return parser.trim();
}
